
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft/[id]",
      function () {
        return require("private-next-pages/nft/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft/[id]"])
      });
    }
  